import React from "react";
import ReactDOM from "react-dom";
import "./index.css";
import App from "./App";
import * as serviceWorker from "./serviceWorker";
import configureStore from "./redux/configureStore";
import { Provider as ReduxProvider } from "react-redux";
import * as networkService from "./authentication/networkService";
import { BrowserRouter } from "react-router-dom";

const rootElement = document.getElementById("root");

const store = configureStore();

networkService.setupInterceptors(store);

ReactDOM.render(
  <ReduxProvider store={store}>   
      <BrowserRouter>
        <App />
      </BrowserRouter>   
  </ReduxProvider>,
  rootElement
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
